export const FINAL_INVOICE = "FINAL_INVOICE";
export const PARTIAL_INVOICE = "PARTIAL_INVOICE";
export const COST_BEARER_INVOICE = "COST_BEARER_INVOICE";

export const CANCELABLE_INVOICE = [FINAL_INVOICE, PARTIAL_INVOICE, COST_BEARER_INVOICE];
